import { call, getContext, put, takeEvery } from 'redux-saga/effects';
import BasketAPI from '../../../api/basket/BasketAPI';
import { basketActions } from '../actions/BasketActions.creators';
import { BasketActionTypes } from '../../../enums/ActionEnums';
export function* removeProductFromBasket(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        yield put(basketActions.createUpdateItemsErrorStateAction(null));
        yield call(BasketAPI.removeProductFromBasket, action.payload.product, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createRemoveSuccessAction(action.payload.product));
    }
    catch (_a) { }
}
export function* removeProductFromBasketSaga() {
    yield takeEvery(BasketActionTypes.REMOVE_PRODUCT, removeProductFromBasket);
}
